import { Reducer } from 'redux';

import {
    IndustriesActions,
    KnownAction,
} from './Actions';

import { NaicsCodeEntity } from '../../Models/Api/strongbox.financialportal';

export interface IIndustriesState {
    // The full list of basic NAICS codes retrieved from the back end.
    naicsCodes: NaicsCodeEntity[];
    // True while a load is in flight.
    loading: boolean;
    // True once a load has completed successfully (used to only load the first time).
    loaded: boolean;
    // Set if the most recent load failed.
    error?: string;
}

const defaultState: IIndustriesState = {
    naicsCodes: [],
    loading: false,
    loaded: false,
}

export const reducer: Reducer<IIndustriesState, KnownAction> = (state: IIndustriesState | undefined, action: KnownAction): IIndustriesState => {
    switch (action.type) {
        case IndustriesActions.LoadStart: {
            return {
                ...(state ? state : defaultState),
                loading: true,
                error: undefined,
            }
        }
        case IndustriesActions.LoadComplete: {
            return {
                ...(state ? state : defaultState),
                loading: false,
                loaded: true,
                naicsCodes: action.naicsCodes,
                error: undefined,
            }
        }
        case IndustriesActions.LoadError: {
            return {
                ...(state ? state : defaultState),
                loading: false,
                loaded: false,
                error: action.error,
            }
        }
    }

    return state ? state : defaultState;
}
